import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { isMobile } from 'react-device-detect'
import { font } from 'assets/themes/theme-default'
import { Button } from '../../index'

const StyledButton = styled(Button)`
  &&& {
    background-color: ${props => props.theme.colors.color1.bg};
    border-color: ${props => props.theme.colors.color1.bg};
    border-radius: 24px;
    padding: 0 10px;
    font-size: ${font.size.base};
    color: #fff;
    text-transform: uppercase;
    min-width: 165px;
    line-height: unset;
    i {
      padding: ${isMobile && '8px'};
      color: #fff;
      margin-left: ${isMobile ? '0' : '25px'};
    }
  }
  :disabled {
    opacity: 0.5;
  }
`

const ButtonNext = props => {
  const { children } = props

  return (
    <StyledButton {...props} data-test="component-next-button">
      {children}
      {/* {isBrowser && children} */}
      {/* {isMobile && <Icon type="right" data-test="next-button-icon" />} */}
    </StyledButton>
  )
}

ButtonNext.propTypes = {
  children: PropTypes.any
}

export default ButtonNext
